/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { DataSourceLoadOptionsBase } from '../models/data-source-load-options-base';
import { LoadResult } from '../models/load-result';
import { TypeDechetParcDto } from '../models/type-dechet-parc-dto';
import { TypesDechetsParcDto } from '../models/types-dechets-parc-dto';


/**
 * Fonctions de gestion des types de déchets des recyparcs
 */
@Injectable({
  providedIn: 'root',
})
export class TypesDechetsRecyparcsService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation typeDechetParcGet
   */
  static readonly TypeDechetParcGetPath = '/api/types-dechets-recyparcs/{id}';

  /**
   * Renvoie le type de déchets du recyparc spécifié.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `typeDechetParcGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  typeDechetParcGet$Response(params: {

    /**
     * Identifiant du type de déchets
     */
    id: number;
  }): Observable<StrictHttpResponse<TypeDechetParcDto>> {

    const rb = new RequestBuilder(this.rootUrl, TypesDechetsRecyparcsService.TypeDechetParcGetPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<TypeDechetParcDto>;
      })
    );
  }

  /**
   * Renvoie le type de déchets du recyparc spécifié.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `typeDechetParcGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  typeDechetParcGet(params: {

    /**
     * Identifiant du type de déchets
     */
    id: number;
  }): Observable<TypeDechetParcDto> {

    return this.typeDechetParcGet$Response(params).pipe(
      map((r: StrictHttpResponse<TypeDechetParcDto>) => r.body as TypeDechetParcDto)
    );
  }

  /**
   * Path part for operation typeDechetParcGetList
   */
  static readonly TypeDechetParcGetListPath = '/api/types-dechets-recyparcs/list/{parcId}';

  /**
   * Renvoie la liste des types de déchets du recyparc spécifié.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `typeDechetParcGetList()` instead.
   *
   * This method doesn't expect any request body.
   */
  typeDechetParcGetList$Response(params: {

    /**
     * Identifiant du recyparc
     */
    parcId: number;
  }): Observable<StrictHttpResponse<Array<TypeDechetParcDto>>> {

    const rb = new RequestBuilder(this.rootUrl, TypesDechetsRecyparcsService.TypeDechetParcGetListPath, 'get');
    if (params) {
      rb.path('parcId', params.parcId, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<TypeDechetParcDto>>;
      })
    );
  }

  /**
   * Renvoie la liste des types de déchets du recyparc spécifié.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `typeDechetParcGetList$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  typeDechetParcGetList(params: {

    /**
     * Identifiant du recyparc
     */
    parcId: number;
  }): Observable<Array<TypeDechetParcDto>> {

    return this.typeDechetParcGetList$Response(params).pipe(
      map((r: StrictHttpResponse<Array<TypeDechetParcDto>>) => r.body as Array<TypeDechetParcDto>)
    );
  }

  /**
   * Path part for operation typeDechetParcLoadList
   */
  static readonly TypeDechetParcLoadListPath = '/api/types-dechets-recyparcs/load-list/{parcId}';

  /**
   * Renvoie la liste des types de déchets du recyparc spécifié (avec support pour groupement, filtrage, pagination et tri).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `typeDechetParcLoadList()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  typeDechetParcLoadList$Response(params: {

    /**
     * Identifiant du recyparc
     */
    parcId: number;

    /**
     * Paramètres de groupement, filtrage, pagination et tri
     */
    body: DataSourceLoadOptionsBase
  }): Observable<StrictHttpResponse<LoadResult>> {

    const rb = new RequestBuilder(this.rootUrl, TypesDechetsRecyparcsService.TypeDechetParcLoadListPath, 'post');
    if (params) {
      rb.path('parcId', params.parcId, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<LoadResult>;
      })
    );
  }

  /**
   * Renvoie la liste des types de déchets du recyparc spécifié (avec support pour groupement, filtrage, pagination et tri).
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `typeDechetParcLoadList$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  typeDechetParcLoadList(params: {

    /**
     * Identifiant du recyparc
     */
    parcId: number;

    /**
     * Paramètres de groupement, filtrage, pagination et tri
     */
    body: DataSourceLoadOptionsBase
  }): Observable<LoadResult> {

    return this.typeDechetParcLoadList$Response(params).pipe(
      map((r: StrictHttpResponse<LoadResult>) => r.body as LoadResult)
    );
  }

  /**
   * Path part for operation typeDechetParcGetListActifs
   */
  static readonly TypeDechetParcGetListActifsPath = '/api/types-dechets-recyparcs/list-actifs/{parcId}';

  /**
   * Renvoie la liste des types de déchets actifs.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `typeDechetParcGetListActifs()` instead.
   *
   * This method doesn't expect any request body.
   */
  typeDechetParcGetListActifs$Response(params: {
    parcId: number;
  }): Observable<StrictHttpResponse<Array<TypeDechetParcDto>>> {

    const rb = new RequestBuilder(this.rootUrl, TypesDechetsRecyparcsService.TypeDechetParcGetListActifsPath, 'get');
    if (params) {
      rb.path('parcId', params.parcId, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<TypeDechetParcDto>>;
      })
    );
  }

  /**
   * Renvoie la liste des types de déchets actifs.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `typeDechetParcGetListActifs$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  typeDechetParcGetListActifs(params: {
    parcId: number;
  }): Observable<Array<TypeDechetParcDto>> {

    return this.typeDechetParcGetListActifs$Response(params).pipe(
      map((r: StrictHttpResponse<Array<TypeDechetParcDto>>) => r.body as Array<TypeDechetParcDto>)
    );
  }

  /**
   * Path part for operation typeDechetParcGetListActifsNoDestination
   */
  static readonly TypeDechetParcGetListActifsNoDestinationPath = '/api/types-dechets-recyparcs/list-actifs/{parcId}/no-destination';

  /**
   * Renvoie la liste des types de déchets actifs qui n'ont pas de destination.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `typeDechetParcGetListActifsNoDestination()` instead.
   *
   * This method doesn't expect any request body.
   */
  typeDechetParcGetListActifsNoDestination$Response(params: {
    parcId: number;
  }): Observable<StrictHttpResponse<Array<TypeDechetParcDto>>> {

    const rb = new RequestBuilder(this.rootUrl, TypesDechetsRecyparcsService.TypeDechetParcGetListActifsNoDestinationPath, 'get');
    if (params) {
      rb.path('parcId', params.parcId, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<TypeDechetParcDto>>;
      })
    );
  }

  /**
   * Renvoie la liste des types de déchets actifs qui n'ont pas de destination.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `typeDechetParcGetListActifsNoDestination$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  typeDechetParcGetListActifsNoDestination(params: {
    parcId: number;
  }): Observable<Array<TypeDechetParcDto>> {

    return this.typeDechetParcGetListActifsNoDestination$Response(params).pipe(
      map((r: StrictHttpResponse<Array<TypeDechetParcDto>>) => r.body as Array<TypeDechetParcDto>)
    );
  }

  /**
   * Path part for operation typeDechetParcGetActifs
   */
  static readonly TypeDechetParcGetActifsPath = '/api/types-dechets-recyparcs/actifs/{parcId}';

  /**
   * Renvoie les types de déchets actifs (détails).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `typeDechetParcGetActifs()` instead.
   *
   * This method doesn't expect any request body.
   */
  typeDechetParcGetActifs$Response(params: {
    parcId: number;
    isChecksum?: boolean;
  }): Observable<StrictHttpResponse<TypesDechetsParcDto>> {

    const rb = new RequestBuilder(this.rootUrl, TypesDechetsRecyparcsService.TypeDechetParcGetActifsPath, 'get');
    if (params) {
      rb.path('parcId', params.parcId, {});
      rb.query('isChecksum', params.isChecksum, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<TypesDechetsParcDto>;
      })
    );
  }

  /**
   * Renvoie les types de déchets actifs (détails).
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `typeDechetParcGetActifs$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  typeDechetParcGetActifs(params: {
    parcId: number;
    isChecksum?: boolean;
  }): Observable<TypesDechetsParcDto> {

    return this.typeDechetParcGetActifs$Response(params).pipe(
      map((r: StrictHttpResponse<TypesDechetsParcDto>) => r.body as TypesDechetsParcDto)
    );
  }

  /**
   * Path part for operation typeDechetParcPut
   */
  static readonly TypeDechetParcPutPath = '/api/types-dechets-recyparcs/{parcId}';

  /**
   * Met à jour le statut d'un type de déchets pour le recyparc spécifié.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `typeDechetParcPut()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  typeDechetParcPut$Response(params: {

    /**
     * Identifiant du recyparc
     */
    parcId: number;

    /**
     * Statut du type de déchets
     */
    body: TypeDechetParcDto
  }): Observable<StrictHttpResponse<TypeDechetParcDto>> {

    const rb = new RequestBuilder(this.rootUrl, TypesDechetsRecyparcsService.TypeDechetParcPutPath, 'put');
    if (params) {
      rb.path('parcId', params.parcId, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<TypeDechetParcDto>;
      })
    );
  }

  /**
   * Met à jour le statut d'un type de déchets pour le recyparc spécifié.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `typeDechetParcPut$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  typeDechetParcPut(params: {

    /**
     * Identifiant du recyparc
     */
    parcId: number;

    /**
     * Statut du type de déchets
     */
    body: TypeDechetParcDto
  }): Observable<TypeDechetParcDto> {

    return this.typeDechetParcPut$Response(params).pipe(
      map((r: StrictHttpResponse<TypeDechetParcDto>) => r.body as TypeDechetParcDto)
    );
  }

  /**
   * Path part for operation typeDechetParcPutMultiple
   */
  static readonly TypeDechetParcPutMultiplePath = '/api/types-dechets-recyparcs/{parcId}/multiple';

  /**
   * Met à jour le statut de plusieurs types de déchets pour le recyparc spécifié.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `typeDechetParcPutMultiple()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  typeDechetParcPutMultiple$Response(params: {

    /**
     * Identifiant du recyparc
     */
    parcId: number;

    /**
     * Statut des types de déchets
     */
    body: Array<TypeDechetParcDto>
  }): Observable<StrictHttpResponse<Array<TypeDechetParcDto>>> {

    const rb = new RequestBuilder(this.rootUrl, TypesDechetsRecyparcsService.TypeDechetParcPutMultiplePath, 'put');
    if (params) {
      rb.path('parcId', params.parcId, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<TypeDechetParcDto>>;
      })
    );
  }

  /**
   * Met à jour le statut de plusieurs types de déchets pour le recyparc spécifié.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `typeDechetParcPutMultiple$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  typeDechetParcPutMultiple(params: {

    /**
     * Identifiant du recyparc
     */
    parcId: number;

    /**
     * Statut des types de déchets
     */
    body: Array<TypeDechetParcDto>
  }): Observable<Array<TypeDechetParcDto>> {

    return this.typeDechetParcPutMultiple$Response(params).pipe(
      map((r: StrictHttpResponse<Array<TypeDechetParcDto>>) => r.body as Array<TypeDechetParcDto>)
    );
  }

}
